import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const SkeletonLoader = ({ 
  type = 'card', 
  count = 1, 
  className = '',
  listClassName = '',
  height = 'auto',
  width = '100%'
}) => {
  const renderSkeleton = () => {
    switch (type) {
      case 'card':
        return (
          <div className="skeleton-card animate-pulse">
            <div className="skeleton-image bg-gray-200 rounded-lg mb-3" style={{ height: '200px' }}></div>
            <div className="skeleton-content space-y-2">
              <div className="skeleton-title bg-gray-200 rounded h-4 w-3/4"></div>
              <div className="skeleton-subtitle bg-gray-200 rounded h-3 w-1/2"></div>
              <div className="skeleton-text bg-gray-200 rounded h-3 w-2/3"></div>
            </div>
          </div>
        );
      
      case 'list':
        return (
          <div className={`skeleton-list-item animate-pulse flex items-center space-x-3 p-3 ${listClassName}`}>
            <div className="skeleton-avatar bg-gray-200 rounded-full h-10 w-10"></div>
            <div className="skeleton-content flex-1 space-y-2">
              <div className="skeleton-title bg-gray-200 rounded h-4 w-1/3"></div>
              <div className="skeleton-subtitle bg-gray-200 rounded h-3 w-1/2"></div>
            </div>
          </div>
        );
      
      case 'table':
        return (
          <div className="skeleton-table animate-pulse">
            <div className="skeleton-header bg-gray-200 rounded h-12 mb-2"></div>
            {[...Array(5)].map((_, index) => (
              <div key={index} className="skeleton-row bg-gray-200 rounded h-16 mb-2"></div>
            ))}
          </div>
        );
      
      case 'form':
        return (
          <div className="skeleton-form animate-pulse space-y-4">
            <div className="skeleton-input bg-gray-200 rounded h-12"></div>
            <div className="skeleton-input bg-gray-200 rounded h-12"></div>
            <div className="skeleton-button bg-gray-200 rounded h-12 w-32"></div>
          </div>
        );
      
      default:
        return (
          <div className="skeleton-default animate-pulse bg-gray-200 rounded" 
               style={{ height, width }}></div>
        );
    }
  };

  if (count === 1) {
    return (
      <div className={`skeleton-loader ${className}`}>
        {renderSkeleton()}
      </div>
    );
  }

  return (
    <div className={`skeleton-loader ${className}`}>
      {[...Array(count)].map((_, index) => (
        <div key={index} className="mb-4">
          {renderSkeleton()}
        </div>
      ))}
    </div>
  );
};

SkeletonLoader.propTypes = {
  type: PropTypes.oneOf(['card', 'list', 'table', 'form', 'default']),
  count: PropTypes.number,
  className: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};

export default SkeletonLoader;
